import { render, staticRenderFns } from "./staffrole.vue?vue&type=template&id=67c7f6d5&scoped=true&"
import script from "./staffrole.vue?vue&type=script&lang=js&"
export * from "./staffrole.vue?vue&type=script&lang=js&"
import style0 from "./staffrole.vue?vue&type=style&index=0&id=67c7f6d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c7f6d5",
  null
  
)

export default component.exports